<div class="title-container">
  <div class="title">{{ automation?.name }}</div>
  <div class="sub-title">{{ automation?.description }}</div>
</div>

<glxy-alert *ngIf="warningMessage !== ''" type="warning" class="snippet-alert">
  {{ warningMessage }}
</glxy-alert>

<mat-dialog-content class="content">
  <div class="right-panel">
    <automata-automation-editor-preview [id]="automation.id" [dontCloseNav]="true"></automata-automation-editor-preview>
  </div>
</mat-dialog-content>

<!-- Actions for templates -->
<mat-dialog-actions *ngIf="!isSnippet; else snippetActions">
  <button mat-stroked-button mat-dialog-close>
    {{ 'COMMON.ACTION_LABELS.CLOSE' | translate }}
  </button>
  <button
    *ngIf="!onlyShowCloseButton"
    mat-flat-button
    color="primary"
    [disabled]="isProcessing"
    (click)="createFromTemplate(automation)"
  >
    <glxy-button-loading-indicator [isLoading]="isProcessing">
      {{ 'AUTOMATIONS.PREVIEW_TEMPLATE_DIALOG.USE_TEMPLATE' | translate }}
    </glxy-button-loading-indicator>
  </button>
</mat-dialog-actions>

<!--Actions for snippet -->
<ng-template #snippetActions>
  <mat-dialog-actions>
    <button mat-stroked-button mat-dialog-close>
      {{ 'COMMON.ACTION_LABELS.CLOSE' | translate }}
    </button>
    <button mat-flat-button color="primary" (click)="useSnippet()" [disabled]="!!warningMessage">
      {{ 'AUTOMATIONS.PREVIEW_SNIPPET_DIALOG.USE_SNIPPET' | translate }}
    </button>
    <button mat-icon-button [matMenuTriggerFor]="menuRef">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menuRef>
      <button mat-menu-item color="warn" (click)="deleteSnippet(automation)">
        {{ 'AUTOMATIONS.PREVIEW_SNIPPET_DIALOG.DELETE_SNIPPET' | translate }}
      </button>
    </mat-menu>
  </mat-dialog-actions>
</ng-template>
